import { render } from "./SearchProteinBar.vue?vue&type=template&id=208d4ba8"
import script from "./SearchProteinBar.vue?vue&type=script&lang=js"
export * from "./SearchProteinBar.vue?vue&type=script&lang=js"

import "./SearchProteinBar.vue?vue&type=style&index=0&id=208d4ba8&lang=css"

import exportComponent from "/home/mihai/repos/skinscience/skinatlas/src/clientapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__